import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { css } from '../../../common/styles/styles.utils';
import { getTitleId } from '../htmlElements/htmlElementsGetter';
import { videoDataSelector } from '../../../common/store/selectors/videoData.selector';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { mediaDataSelector } from '../../../common/store/selectors/mediaData.selector';

interface TitleTextProps {
    titleStyle: any;
}

export const TitleText: FunctionComponent<TitleTextProps> = props => {
  const { titleStyle } = props;

  const title = useSelector(videoDataSelector.title);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const showTitle = useSelector(mediaDataSelector.showTitle);

  return showTitle
    ? (
      <span style={css(titleStyle)} id={getTitleId(playerUniqueId)}>
        {title}
      </span>
    )
    : null;
};
